<template>
  <form-group v-if="shopeeAccounts.length" :columns="12" label="Conta">
    <select class="form-select" v-model="account">
      <option value="">Selecione</option>
      <option v-for="account in shopeeAccounts" :key="account.shopId" :value="account.shopId">
        {{ account.shopName }} ({{ account.shopId }})
      </option>
    </select>
  </form-group>
</template>

<script>
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      account: '',
      shopeeAccounts: []
    }),
    async mounted () {
      this.shopeeAccounts = (await api.shopee.getAccounts({})).items
    },
    methods: {
      async syncOrder (data) {
        await api.shopee.syncOrder(data.type, data.identifier, data.code, this.account)
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SyncDialog.vue?c5d59a54